export const XML_PARSE_ERROR_TAG_NAME: string = 'parsererror';

export const isXmlParseErrorElement = (element: Element | null | undefined): boolean =>
    element?.tagName.toLowerCase() === XML_PARSE_ERROR_TAG_NAME;

export const getXmlParseErrorElement = (document: Document): Element | null => {
    if (isXmlParseErrorElement(document.documentElement)) return document.documentElement;
    return document.querySelector(XML_PARSE_ERROR_TAG_NAME);
};

export const hasXmlParseErrorElement = (document: Document): boolean => getXmlParseErrorElement(document) !== null;
